module.exports = __webpack_public_path__ + "0da5eee18521345fc9e5438cd0d51337.png";